const skills = {
    1: [
      {
        title: "C/C++",
        level: 6,
      },
      {
        title: "Python",
        level: 6,
      },
      {
        title: "Java",
        level: 5,
      },
      {
        title: "SQL",
        level: 4,
      },
      {
        title: "HTML",
        level: 6,
      },
      {
        title: "CSS",
        level: 6,
      },
      {
        title: "Javascript",
        level: 3,
      },
      {
        title: "React JS",
        level: 2,
      },
    ],
    2: [
      {
        title: "Verilog",
        level: 6,
      },
      {
        title: "SystemVerilog",
        level: 5,
      },
      {
        title: "FPGAs",
        level: 3,
      },
      {
        title: "Oscilloscopes",
        level: 5,
      },
      {
        title: "Multimeters",
        level: 3,
      },
      {
        title: "Amplifiers",
        level: 4,
      },
      {
        title: "Rectifiers",
        level: 3,
      },
      {
        title: <k1>Virus-Fighting</k1>,
        level: 6,
      },
    ],
  };
  
  export default skills;
  